import { z } from "zod";

export const CONTRAGENT_SCHEME = z.object({
    iin: z.string("Введите ИИН полностью")
        .min(12, "Введите ИИН полностью"),
    name:
        z.string("Введите имя полностью")
            .min(1, "Введите имя полностью").regex(/^[а-яА-ЯёЁa-zA-Z\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB\s-]+$/, "Недопустимый символ"),
    surname:
        z.string("Введите фамилию полностью")
            .min(1, "Введите фамилию полностью").regex(/^[а-яА-ЯёЁa-zA-Z\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB\s-]+$/, "Недопустимый символ"),
    patronymic:
        z.string("Введите отчество полностью")
            .min(1, "Введите отчество полностью").regex(/^[а-яА-ЯёЁa-zA-Z\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB\s-]+$/, "Недопустимый символ"),
    date_of_birth: z.string("Введите дату рождения полностью"),
    sex: z.enum(["М", "Ж"], "Выберите пол"),
    phone: z.string("Введите номер телефона")
        .regex(/\+7 \(\d{3}\) \d{3} \d{2} \d{2}/, "Введите номер телефона полностью"),
    email: z.string("Введите email полностью")
        .email("Введите валидный email"),
    doc_type: z.number("Укажите тип документа")
        .min(4, "Укажите тип документа"),
    doc_number: z.string().min(2, { message: "Укажите номер документа" })
})